export default "__VITE_ASSET__6NcXdXai__"